import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useHelp } from './HelpContext'
import { CHECKLIST } from './content'
import './help.css'

// Checklist of the first things to try. Steps tick themselves as they are
// done anywhere in the app; nothing here is clicked off by hand.
function GettingStarted() {
  const { loaded, steps, refresh } = useHelp()

  useEffect(() => {
    refresh()
  }, [refresh])

  if (!loaded) return null
  const done = CHECKLIST.filter((step) => steps.has(step.id)).length
  const percent = Math.round((done / CHECKLIST.length) * 100)

  return (
    <section className="help-start" aria-label="Getting started">
      <div className="help-start-head">
        <h2 className="help-start-title">Getting started</h2>
        <span className="help-start-count">
          {done} of {CHECKLIST.length} done
        </span>
      </div>
      <div className="help-start-bar" aria-hidden="true">
        <div className="help-start-fill" style={{ width: `${percent}%` }} />
      </div>
      {done === CHECKLIST.length ? (
        <p className="help-start-done">
          You have tried every core feature. The ? menu in the top bar still has each page’s tour and tips.
        </p>
      ) : null}
      <ol className="help-start-list">
        {CHECKLIST.map((step) => {
          const complete = steps.has(step.id)
          return (
            <li key={step.id} className={'help-start-step' + (complete ? ' is-done' : '')}>
              <span className="help-start-check" aria-hidden="true">
                {complete ? '✓' : ''}
              </span>
              <div className="help-start-text">
                <div className="help-start-name">{step.title}</div>
                <div className="help-start-desc">{step.body}</div>
              </div>
              {complete ? null : (
                <Link className="help-start-go" to={step.to}>
                  Go
                </Link>
              )}
            </li>
          )
        })}
      </ol>
    </section>
  )
}

export default GettingStarted
